import { Component, OnInit } from '@angular/core';
import { AddressDto, ConnectionPointCategoryDto, ConnectionPointDto, ConnectionPointService, ConnectionPointAccessKeyDto } from '@app/api/nts';
import { ControlsOf, FormGroupType } from '@app/core/utils/formgroup-type';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { addressFormGroup } from '@shared/forms/address.formgroup';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { TabComponent } from '@shared/components/tabs/tab/tab.component';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { AddressComponent } from '@shared/components/address/address.component';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-connectionpoint-edit',
  imports: [
    TabsComponent,
    TabComponent,
    ReactiveFormsModule,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    AddressComponent,
  ],
  templateUrl: './connectionpoint-edit.component.html',
  styleUrl: './connectionpoint-edit.component.css'
})
export class ConnectionpointEditComponent implements OnInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroupType<ConnectionPointDto> = new FormGroup<ControlsOf<ConnectionPointDto>>({
      id: new FormControl(null, Validators.required),
      identification: new FormControl(null, Validators.required),
    alternativeIdentification: new FormControl(null),
    stationNumber: new FormControl(null),
    connectionPointCategoryId: new FormControl(null, Validators.required),
      maximumPower: new FormControl(null),
      maximumCurrent: new FormControl(null),
      description: new FormControl(null),
      address: new FormGroup(addressFormGroup),
      accessKey: new FormGroup<ControlsOf<ConnectionPointAccessKeyDto>>({
        number: new FormControl<string | null>(null),
        placementType: new FormControl<string | null>(null),
        code: new FormControl<string | null>(null),
        remarks: new FormControl<string | null>(null),
        facility: new FormControl<string | null>(null),
      } as any),
    }
  )

  public id?: string;
  public connectionPoint?: ConnectionPointDto;

  public connectionpointCategories: ConnectionPointCategoryDto[] = [];
  public mpTypeList: KeyValue[] = [];

  constructor(
    private readonly connectionPointService: ConnectionPointService,
    private readonly formApiService: FormApiService,
  ) {
  }

  public ngOnInit(): void {
    this.connectionPointService.connectionPointCategoriesGet().subscribe({
        next: (data: ConnectionPointCategoryDto[]) => {
          this.connectionpointCategories = data;

          this.mpTypeList = data.map(category => ({
            key: category.id ?? '',
            value: category.name ?? ''
          }));
        },
        complete: () => {
          if (this.connectionPoint) {
            this.form.patchValue({ ...this.connectionPoint, accessKey: this.connectionPoint.accessKey ?? {} as any });
          } else if (this.id) {
            this.connectionPointService.connectionPointGetGet(this.id).subscribe({
                next: (result) => {
                  this.form.patchValue({ ...result, accessKey: result.accessKey ?? {} as any });
                }
              }
            )
          }
        }
      },
    )
  }

  public addressChanged(address: AddressDto): void {
    this.form.get('address')?.patchValue(address);
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data: ConnectionPointDto) => this.connectionPointService.connectionPointEditPost(data),
      {
        closeModal: true,
        successMessage: 'connectionpoint.edit.success'
      }
    )
  }
}
